// extracted by mini-css-extract-plugin
module.exports = {"divisor":"style_divisor__7UPQX","container":"style_container__Rh4ge","powered":"style_powered__UQN19","version":"style_version__3lkyg"};